var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngleRight = function SvgAngleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 19.256a.76.76 0 0 1 .204-.506l6.189-6.752-6.189-6.75a.7.7 0 0 1-.149-.239.78.78 0 0 1 .061-.688.7.7 0 0 1 .302-.268.6.6 0 0 1 .387-.038c.13.03.249.101.341.205l6.659 7.265a.76.76 0 0 1 .195.513c0 .193-.07.378-.195.514l-6.659 7.265a.65.65 0 0 1-.344.208.6.6 0 0 1-.392-.04.7.7 0 0 1-.302-.276.8.8 0 0 1-.108-.413"
  })));
};
export { SvgAngleRight as ReactComponent };